import { z } from 'zod';

const schema = z.object({
  MODE: z.string().trim().min(1),
  VITE_ENVIRONMENT: z.string().trim().optional(),
});

const parsed = schema.parse(import.meta.env);

export const environmentLabel = parsed.VITE_ENVIRONMENT || parsed.MODE;
